import '../../app-configuration/app-configuration.js';
import { KatapultElement, html } from '../../mixins/katapult-element.js';
import '@polymer/paper-styles/color.js';
import '@polymer/paper-styles/shadow.js';
import '@polymer/font-roboto/roboto.js';
import '@polymer/paper-tooltip/paper-tooltip.js';
import '../katapult-auth/katapult-auth.js';
import '../katapult-drop-down/katapult-drop-down.js';
import '../katapult-3d-view/katapult-3d-view.js';
import '../google-apis/google-maps-api.js';
import '../material-icon/material-icon';
import { KatapultModel } from '../../modules/katapult-model/KatapultModel.js';
import { KatapultJob } from '../../modules/katapult-job/KatapultJob.js';
import '../job-chooser/job-chooser.js';
import '../katapult-search/katapult-search.js';
import '../hash-bind/hash-bind.js';
import '../katapult-toolbar/katapult-toolbar.js';
import '../katapult-elements/katapult-dialog.js';
import '../release-notes-dialog/release-notes-dialog.js';
import { addListener, setTouchAction } from '@polymer/polymer/lib/utils/gestures.js';
import { ModelDefaults } from '../../modules/ModelDefaults.js';
import { PickAnAttribute } from '../../modules/PickAnAttribute.js';
import { Clamp } from '../../modules/Clamp.js';
import { getVersionNameFromOrigin } from '../../modules/CheckOrigin.js';
import { SHOW_ALL_3D_VIEW_GROUPS_ID } from '../../modules/Get3dViewGroups.js';
import { logger } from '@sentry/browser';

/** @import { PaperMenuButton } from '@polymer/paper-menu-button'; */

class Katapult3dModel extends KatapultElement {
  static get template() {
    return html`
      <style>
        :host {
          overflow: hidden;
          position: absolute;
          height: 100%;
          width: 100%;
          font-family: Roboto;
        }
        #stateButtons {
          display: flex;
          gap: 4px;
        }
        #stateButtons > katapult-button:hover {
          background-color: var(--paper-grey-100);
        }
        #stateButtons > [disabled] {
          color: var(--paper-grey-300);
        }
        #stateButtons > [name='showClearances'][active] {
          color: var(--paper-green-500);
        }
        #stateButtons > [name='showKpla'][active] {
          color: var(--paper-green-500);
        }
        #toolbarContainer {
          display: block;
        }
        #sidePanelContainer {
          display: none;
        }
        @media (max-width: 1350px) {
          #toolbarContainer {
            display: none;
          }
          #sidePanelContainer {
            display: block;
          }
        }
        /* Mobile sidebar styles */
        #topBar {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          z-index: 2;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 12px;
          box-sizing: border-box;
        }
        #newVersionTag {
          position: absolute;
          top: 8px;
          left: 40px;
          background-color: var(--secondary-color);
          border: 1px solid white;
          color: white;
          padding: 2px 6px;
          border-radius: 16px;
          font-size: 12px;
          font-weight: bold;
          pointer-events: none;
        }
        #sidePanel {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 320px;
          max-width: 100%;
          background-color: white;
          z-index: 99;
          left: -100%;
          @apply --shadow-elevation-2dp;
        }
        #sidePanel:not([dragging]) {
          transition: left 0.3s;
        }
        #sidePanel[opened=''] {
          left: 0;
        }
        #sidePanelScroll {
          height: inherit;
          box-sizing: border-box;
          overflow-y: auto;
          padding: 12px;
          display: flex;
          flex-direction: column;
        }
        #sidePanelScroll::-webkit-scrollbar {
          background-color: white;
        }
        #sidePanelScroll::-webkit-scrollbar-thumb {
          background-color: rgba(50, 50, 50, 0.5);
          border: 3px solid transparent;
          border-radius: 9px;
        }
        #sidePanelScroll > * {
          flex-shrink: 0;
        }
        #sidePanelTopButtonsContainer {
          border-radius: 999px;
          background-color: var(--paper-grey-200);
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
          margin-top: 5px;
        }
        #sidePanelTopButtonsContainer paper-menu-button {
          padding: 0;
        }
        #sidePanelTopButtonsContainer login-chip {
          overflow: hidden;
          --user-chip-profile: {
            width: 24px;
            height: 24px;
            margin: 4px;
          };
        }
        #jobChooserContainer {
          height: 48px;
          margin: 8px 0;
        }
        #sidePanelRows {
          display: flex;
          flex-direction: column;
          padding: 10px 0;
        }
        #sidePanelRows paper-item {
          margin: 2px 0;
        }
      </style>
      <hash-bind prop1="{{jobId}}" prop2="{{selectedNodeId}}"></hash-bind>
      <katapult-auth
        user="{{user}}"
        user-group="{{userGroup}}"
        signed-in="{{signedIn}}"
        read-only="{{readOnlyUser}}"
        title="[[config.firebaseData.name]] 3D Models"
        signup-link="https://katapultpro.com/signup"
        no-signup="[[!config.firebaseData.offerLicenses]]"
      >
        <div slot="title-content">
          <p style="margin: 0;">[[config.firebaseData.name]] 3D Models</p>
        </div>
        <div id="loginDescription" slot="description-content">
          <p>[[config.firebaseData.name]] 3D Models allows you to view a live 3D rendering of your entire job.</p>
          <template is="dom-if" if="{{appNameContains(config.firebaseData.name, 'katapult')}}">
            <p>
              Need some help? View our
              <a href="https://katapultpro.com/help/" style="color: white; font-weight: normal; text-decoration: none;">Docs</a>
            </p>
          </template>
        </div>
        <div id="main" slot="auth-content">
          <release-notes-dialog
            id="releaseNotes"
            uid="[[user.uid]]"
            user-group="[[userGroup]]"
            name="[[config.firebaseData.name]]"
            code-version="[[config.version]]"
            on-release-notes-update="notifyNewVersion"
          ></release-notes-dialog>
          <div id="sidePanelContainer">
            <div id="topBar">
              <div style="display: flex; flex-basis: 0; flex-grow: 1;">
                <katapult-button
                  icon="menu"
                  iconOnly
                  noBorder
                  style="border-radius: 999px;"
                  color="white"
                  on-touchstart="toggleShowSidePanel"
                  on-mousedown="toggleShowSidePanel"
                ></katapult-button>
                <div id="newVersionTag" hidden$="[[!isNewVersion]]">NEW</div>
              </div>
            </div>
            <div id="sidePanel" katapult-drop-down-disable-scrolling opened$="[[showSidePanel]]">
              <div id="sidePanelScroll">
                <div id="sidePanelTopButtonsContainer">
                  <katapult-button
                    iconOnly
                    noBorder
                    icon="close"
                    on-touchstart="toggleShowSidePanel"
                    on-mousedown="toggleShowSidePanel"
                  ></katapult-button>
                  <katapult-button iconOnly noBorder id="hardRefreshButton" icon="refresh" on-click="hardReload"></katapult-button>
                  <paper-menu-button id="helpDrawerMenu" horizontal-align="center" vertical-align="top" no-overlap>
                    <katapult-button iconOnly noBorder icon="help" slot="dropdown-trigger"></katapult-button>
                    <div id="helpDrawer" slot="dropdown-content" style="padding: 16px;">
                      <div style="display: flex; flex-direction: column; gap: 8px;">
                        <version-selector-button
                          style="box-sizing: border-box;"
                          current-version-name="[[currentVersionName]]"
                        ></version-selector-button>
                        <katapult-button style="box-sizing: border-box;" on-click="openBugFeedback" icon="bug_report"
                          >Report Bug</katapult-button
                        >
                        <katapult-button style="box-sizing: border-box;" on-click="openTrainingPage" icon="help"
                          >Training Resources</katapult-button
                        >
                      </div>
                    </div>
                  </paper-menu-button>
                  <login-chip hide-name user-group="[[userGroup]]"></login-chip>
                </div>
                <div id="jobChooserContainer">
                  <job-chooser
                    underline
                    alphabetical="[[orderJobsAlphabetically]]"
                    no-create-new-job
                    hidden$="{{welcomeDialogOpened}}"
                    selected="{{jobId}}"
                    user-group="[[userGroup]]"
                    disabled="{{isJobAuth}}"
                    firebase-disabled="[[!signedIn]]"
                    job-name="{{jobName}}"
                    select-on-focus=""
                    model-options="[[modelOptions]]"
                    show-job-creator="[[showEditCreator(modelOptions)]]"
                    on-set-job-id="setJobId"
                    on-duplicate-job-data="duplicateJobData"
                    on-delete-job="deleteJob"
                    on-toast="displayToastMessage"
                    on-search-focused="scrollToCurrent"
                    on-open-folder-chooser="openFolderChooser"
                    folder-chooser-opened="[[folderChooserOpened]]"
                  ></job-chooser>
                </div>
                <katapult-drop-down
                  id="poleList"
                  items="[[poleList]]"
                  label-path="label"
                  value-path="nodeId"
                  value="{{selectedNodeId}}"
                  label="Search Poles/Location"
                ></katapult-drop-down>
                <template is="dom-if" if="[[hasMultipleRenderGroups(renderGroups)]]">
                  <katapult-drop-down
                    id="mobileRenderGroupChooser"
                    style="margin-top: 12px;"
                    items="[[getRenderGroupOptions(renderGroups)]]"
                    label-path="label"
                    value-path="id"
                    value="{{selectedRenderGroupId}}"
                    no-clear=""
                    label="Pole Group"
                    on-selected-changed="renderGroupSelectionChanged"
                  ></katapult-drop-down>
                  <paper-tooltip for="mobileRenderGroupChooser"
                    >Groups split at connections over one mile or between disconnected pole networks.</paper-tooltip
                  >
                </template>
                <div id="sidePanelRows">
                  <div style="padding:10px; display:flex;" on-click="toggleState" name="showClearances">
                    <paper-toggle-button checked="[[showClearances]]" disabled="[[renderingPoles]]"></paper-toggle-button>
                    <span style="margin-left: 10px; margin-right: 5px;">Make Ready View</span>
                  </div>
                  <!-- <template is="dom-if" if="[[jobCreatorHasPoleLoadingModels]]"> -->
                  <div style="padding:10px; display:flex;" on-click="toggleState" name="showKpla">
                    <paper-toggle-button checked="[[showKpla]]" disabled="[[renderingPoles]]"></paper-toggle-button>
                    <span style="margin-left: 10px; margin-right: 5px;">Pole Loading View</span>
                  </div>
                  <!-- </template> -->
                  <div style="padding:10px; display:flex;">
                    <paper-toggle-button checked="{{syncPoleWithMap}}" on-checked-changed="_syncPoleWithMapChanged"></paper-toggle-button>
                    <span style="margin-left: 10px; margin-right: 5px;">Sync with Map Page</span>
                  </div>
                </div>
                <div style="flex-grow: 1;"></div>
                <div style="display: flex; flex-direction: column; font-size: 10pt; gap: 8px;">
                  <katapult-button
                    on-click="openReleaseNotes"
                    hidden$="[[isNewVersion]]"
                    bordercolor="var(--secondary-color)"
                    textcolor="var(--secondary-color)"
                    >Release Notes</katapult-button
                  >
                  <katapult-button
                    on-click="openReleaseNotes"
                    icon="campaign"
                    hidden$="[[!isNewVersion]]"
                    color="var(--secondary-color)"
                    textcolor="white"
                    >What's New</katapult-button
                  >
                  <p style="margin: 0;">Version: {{config.version}} ({{config.buildNumber}})</p>
                  <p style="margin: 0;">Build Date: {{config.buildDate}}</p>
                </div>
              </div>
            </div>
          </div>
          <div id="toolbarContainer">
            <katapult-toolbar
              id="toolbar"
              style="flex-shrink: 0;"
              user-group="[[userGroup]]"
              flexible-regions$="[[pinSearchBar]]"
              job-id="[[jobId]]"
              job-creator="[[jobCreator]]"
              selected-node="[[selectedNodeId]]"
              active-connection="[[activeConnection]]"
            >
              <job-chooser
                slot="left"
                underline
                alphabetical="[[orderJobsAlphabetically]]"
                no-create-new-job
                hidden$="{{welcomeDialogOpened}}"
                selected="{{jobId}}"
                user-group="[[userGroup]]"
                disabled="{{isJobAuth}}"
                firebase-disabled="[[!signedIn]]"
                job-name="{{jobName}}"
                select-on-focus=""
                model-options="[[modelOptions]]"
                show-job-creator="[[showEditCreator(modelOptions)]]"
                on-set-job-id="setJobId"
                on-duplicate-job-data="duplicateJobData"
                on-delete-job="deleteJob"
                on-toast="displayToastMessage"
                on-search-focused="scrollToCurrent"
                on-open-folder-chooser="openFolderChooser"
                folder-chooser-opened="[[folderChooserOpened]]"
              ></job-chooser>
              <div slot="left" style="flex-grow: 1;"></div>
              <!-- Center Slot Content -->
              <div slot="center" style="display: flex; justify-content: center; align-items: center; gap: 16px;">
                <katapult-drop-down
                  id="poleList"
                  items="[[poleList]]"
                  label-path="label"
                  value-path="nodeId"
                  value="{{selectedNodeId}}"
                  label="Search Poles/Location"
                ></katapult-drop-down>
                <template is="dom-if" if="[[hasMultipleRenderGroups(renderGroups)]]">
                  <katapult-drop-down
                    id="desktopRenderGroupChooser"
                    style="width: 240px; flex-shrink: 0;"
                    items="[[getRenderGroupOptions(renderGroups)]]"
                    label-path="label"
                    value-path="id"
                    value="{{selectedRenderGroupId}}"
                    no-clear=""
                    label="Pole Group"
                    on-selected-changed="renderGroupSelectionChanged"
                  ></katapult-drop-down>
                  <paper-tooltip for="desktopRenderGroupChooser"
                    >Groups split at connections over one mile or between disconnected pole networks.</paper-tooltip
                  >
                </template>
              </div>
              <!-- Right Slot Content -->
              <div slot="right" style="flex-grow: 1;"></div>
              <template is="dom-if" if="[[jobId]]">
                <div id="stateButtons" slot="right" style="text-align:center;">
                  <!-- todo - properly hide these buttons if kpla or mr not enabled -->
                  <katapult-button
                    id="mrViewButton"
                    name="showClearances"
                    icon="format_line_spacing"
                    iconOnly
                    noBorder
                    noBackground
                    loading="[[renderingPoles]]"
                    on-click="toggleState"
                    text-color="[[if(showClearances, '#66bb6a', 'black')]]"
                    hidden$="[[equal(makeReadyClearances.length, 0)]]"
                  ></katapult-button>
                  <paper-tooltip for="mrViewButton">Make Ready View</paper-tooltip>
                  <katapult-button
                    id="kplaViewButton"
                    name="showKpla"
                    icon="compare_arrows"
                    iconOnly
                    noBorder
                    noBackground
                    disabled="[[renderingPoles]]"
                    on-click="toggleState"
                    text-color="[[if(showKpla, '#66bb6a', 'black')]]"
                    hidden$="[[!jobCreatorHasPoleLoadingModels]]"
                  ></katapult-button>
                  <paper-tooltip for="kplaViewButton">Pole Loading View</paper-tooltip>
                  <paper-toggle-button
                    id="syncPoleWithMap"
                    style="--primary-color: var(--secondary-color); justify-content: center; flex-shrink: 0; font-size: 14px;"
                    checked="{{syncPoleWithMap}}"
                    on-checked-changed="_syncPoleWithMapChanged"
                    slot="right"
                    >Sync with Map Page</paper-toggle-button
                  >
                  <paper-tooltip for="syncPoleWithMap">Keep this page in sync with the selected pole on the map page</paper-tooltip>
                </div>
              </template>
            </katapult-toolbar>
          </div>

          <!-- Loaded here, not in katapult-3d-view, since hosts like the map page already load the Maps API -->
          <google-maps-api api-key="[[config.mapsApiKey]]" channel="[[userGroup]]" on-api-load="googleMapsApiLoaded"></google-maps-api>
          <katapult-3d-view
            id="view"
            job-id="[[jobId]]"
            selected-node-id="{{selectedNodeId}}"
            render-groups="{{renderGroups}}"
            selected-render-group-id="{{selectedRenderGroupId}}"
            fps="{{fps}}"
            show-clearances="{{showClearances}}"
            show-kpla="{{showKpla}}"
            rendering-poles="{{renderingPoles}}"
            user="[[user]]"
            user-group="[[userGroup]]"
            sync-pole-with-map="[[syncPoleWithMap]]"
            model-defaults="[[modelDefaults]]"
            job-creator="[[jobCreator]]"
            on-nodes-changed="setNodes"
            on-show-specs-warning="showSpecsWarning"
            on-click="closeSidePanel"
          ></katapult-3d-view>

          <katapult-dialog id="specsWarning" title="Missing Pole Loading Specs" width="600">
            <div>
              3D View leverages Integrated Pole Loading to render detailed pole models. To configure your models for Integrated Pole
              Loading, please contact <a href="mailto:">support@katapultengineering.com</a>.
            </div>
            <katapult-button slot="buttons" color="var(--secondary-color)" dialog-dismiss>Continue without specs</katapult-button>
          </katapult-dialog>
        </div>
      </katapult-auth>
    `;
  }

  static get is() {
    return 'katapult-3d-model';
  }
  static get properties() {
    return {
      jobId: {
        type: String
      },
      renderingPoles: {
        type: Boolean,
        value: false
      },
      renderGroups: {
        type: Array,
        value: () => [],
        observer: 'renderGroupsChanged'
      },
      selectedRenderGroupId: {
        type: String,
        value: SHOW_ALL_3D_VIEW_GROUPS_ID
      },
      syncPoleWithMap: {
        type: Boolean,
        value: true
      },
      jobCreator: {
        type: String
      },
      modelDefaults: {
        type: Object,
        computed: 'computeModelDefaults(configDefaults, otherAttributes)',
        value: () => ({})
      },
      isNewVersion: {
        type: Boolean,
        value: false
      }
    };
  }
  static get observers() {
    return ['getPoleList(nodes)', 'sortPoleList(selectedNodeId)', '_updateJobCreator(jobId)', '_updateModelListeners(jobCreator)'];
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this._unsubscribeConfigDefaults?.();
    this._unsubscribeOtherAttributes?.();
    this._unsubscribeJobCreator?.();
  }

  async _updateJobCreator(jobId) {
    this._unsubscribeJobCreator?.();
    if (!jobId) {
      this.jobCreator = null;
      return;
    }
    this._unsubscribeJobCreator = KatapultJob.fromId(jobId).onModelSnapshot((snapshot) => {
      this.jobCreator = snapshot.val();
    });
  }

  _updateModelListeners(jobCreator) {
    this._unsubscribeConfigDefaults?.();
    this._unsubscribeOtherAttributes?.();
    if (!jobCreator) {
      this.configDefaults = null;
      this.otherAttributes = null;
      return;
    }
    const model = KatapultModel.fromId(jobCreator);
    this._unsubscribeConfigDefaults = model.onModelPathSnapshot('models/config/defaults', (snapshot) => {
      this.configDefaults = snapshot.val();
    });
    this._unsubscribeOtherAttributes = model.onAttributesSnapshot((snapshot) => {
      this.otherAttributes = snapshot.val();
    });
  }

  constructor() {
    super();

    // Set property defaults
    this.currentVersionName = getVersionNameFromOrigin();
  }

  async ready() {
    await super.ready();

    this.appConfiguration = new AppConfiguration(this);

    // Set up the side panel drag event listeners
    const sidePanel = /** @type EventTarget */ (this.shadowRoot?.querySelector('#sidePanel'));
    addListener(sidePanel, 'track', (event) => this.sidePanelTrack(event));
    // Let browser handle vertical scrolling and zoom
    setTouchAction(sidePanel, 'pan-y pinch-zoom');
  }

  if(condition, option1, option2) {
    return condition ? option1 : option2;
  }

  appNameContains(appName, searchString) {
    return (appName || '').toLowerCase().indexOf(searchString.toLowerCase()) != -1;
  }

  toggleState(e) {
    let prop = e.currentTarget.getAttribute('name');
    this[prop] = !this[prop];

    // Track when a feature is enabled
    if (this[prop]) logger.info(`${prop} enabled`);
  }
  hasMultipleRenderGroups(renderGroups) {
    return (renderGroups?.length ?? 0) > 1;
  }
  getRenderGroupOptions(renderGroups) {
    return [{ id: SHOW_ALL_3D_VIEW_GROUPS_ID, label: 'Show all groups' }, ...(renderGroups ?? [])];
  }
  renderGroupsChanged(renderGroups) {
    const selectedGroup = this.getRenderGroupOptions(renderGroups).find((group) => group.id === this.selectedRenderGroupId);
    if (!selectedGroup) return;

    requestAnimationFrame(() => {
      if (renderGroups !== this.renderGroups) return;

      for (const dropdown of this.shadowRoot?.querySelectorAll('katapult-drop-down') ?? []) {
        if (dropdown.label !== 'Pole Group' || dropdown.selectedItem === selectedGroup) continue;

        const inputIsFocused = dropdown.$?.input?.focused;
        dropdown.selectedItem = selectedGroup;
        if (!dropdown.opened && !inputIsFocused) dropdown.updateSearchText();
      }
    });
  }
  renderGroupSelectionChanged(event) {
    this.$?.view?.selectRenderGroup(event.detail.value);
  }
  googleMapsApiLoaded() {
    this.$?.view?.googleMapsApiLoaded();
  }

  /**
   * Gets the nodes from the 3d view and sets them in this element
   * @param {object} e - Event data for the change in nodes from katapult-3d-view
   */
  setNodes(e) {
    this.nodes = e.detail.value;
  }

  /**
   * Computes the list of model default using the config defaults and attributes stored in the models
   * @param {object} configDefaults - The default values for the model
   * @param {object} otherAttributes - Attributes in the current job's models
   * @returns {object} - An object containing the current model defaults
   */
  computeModelDefaults(configDefaults, otherAttributes) {
    return ModelDefaults(configDefaults, otherAttributes);
  }
  /**
   * Takes an object of notes and converts it to a list of poles sorted by the current ordering attribute.
   * Then, it sets the resulting array to the global poleList property.
   */
  getPoleList() {
    if (!this.nodes) return;
    // Convert the object to an array
    const nodes = Object.entries(this.nodes || {}).map(([key, value]) => {
      // get the label from the attributes
      const orderingAttribute = this.modelDefaults?.ordering_attribute || 'scid';
      const label = PickAnAttribute(value.attributes, orderingAttribute) ?? key;
      // return the node object with its data, the nodeId, and the label
      return { ...value, nodeId: key, label };
    });
    // Filter the nodes to only show poles
    const poles = nodes.filter((node) => {
      const nodeType = this.modelDefaults?.pole_node_types?.[0] || 'pole';
      return PickAnAttribute(node.attributes, 'node_type') == nodeType;
    });
    // Set the pole list to the poles
    this.set('poleList', poles);
    // Sort the poles and set them to the pole list
    this.sortPoleList();
  }

  /**
   * Sorts the pole list and sets it.  If the pole list is empty, it does nothing.
   */
  sortPoleList() {
    if (this.poleList == null || this.poleList.length == 0) return;
    // Sort the list by its label
    const sortedPoles = this.poleList.sort((a, b) => {
      if (a.label.trim() < b.label.trim()) return -1;
      if (a.label.trim() > b.label.trim()) return 1;
      return 0;
    });
    this.set('poleList', sortedPoles);
  }

  showSpecsWarning() {
    this.$.specsWarning.open();
  }

  toggleShowSidePanel(e) {
    e.preventDefault();
    e.stopPropagation();
    this.showSidePanel = !this.showSidePanel;
    if (!this.showSidePanel) {
      /** @type PaperMenuButton */ (this.shadowRoot?.querySelector('#helpDrawerMenu'))?.close();
      this.ignoreSidePanelTrack = true;
      setTimeout(() => (this.ignoreSidePanelTrack = false), 300);
    }
  }

  closeSidePanel(e) {
    this.shadowRoot?.querySelector('login-chip')?.closeMenu();
    /** @type PaperMenuButton */ (this.shadowRoot?.querySelector('#helpDrawerMenu'))?.close();
    if (this.showSidePanel) this.showSidePanel = false;
  }

  sidePanelTrack(e) {
    if (this.ignoreSidePanelTrack) return;
    const sidePanel = /** @type HTMLElement */ (this.shadowRoot?.querySelector('#sidePanel'));
    if (!sidePanel) return;

    if (e.detail.state === 'start') {
      this.sidePanelOffsetLeft = sidePanel.offsetLeft;
      this.sidePanelOffsetWidth = sidePanel.offsetWidth;
      this.sidePanelDraggingHorizontally =
        (e.detail.ddx != null && e.detail.ddy != null && Math.abs(e.detail.ddx) > Math.abs(e.detail.ddy)) ||
        (e.detail.dx != null && e.detail.dy != null && Math.abs(e.detail.dx) > Math.abs(e.detail.dy));
    }
    if (this.sidePanelDraggingHorizontally) {
      sidePanel.setAttribute('dragging', true);
      sidePanel.style.left = Clamp(this.sidePanelOffsetLeft + e.detail.dx, -this.sidePanelOffsetWidth, 0) + 'px';
    }
    if (e.detail.state === 'end') {
      sidePanel.removeAttribute('dragging');
      this.showSidePanel = Math.abs(sidePanel.offsetLeft) < this.sidePanelOffsetWidth / 2 && this.sidePanelLastDDX > -6;
      if (!this.showSidePanel) this.closeSidePanel();
      sidePanel.style.removeProperty('left');
    }
    this.sidePanelLastDDX = e.detail.ddx;
  }

  hardReload() {
    window.location.reload(true);
  }

  notifyNewVersion() {
    this.isNewVersion = true;
  }

  openReleaseNotes() {
    this.$.releaseNotes.open();
    this.isNewVersion = false;
  }

  _syncPoleWithMapChanged(e) {
    const value = e.detail.value;
    if (value === false) logger.info('Sync with map page disabled');
  }
}
window.customElements.define(Katapult3dModel.is, Katapult3dModel);
